import { useQuery } from '@tanstack/react-query';
import { useVenoSDK } from '@ui/providers/VenoSDKProvider';
import { getQuery } from '@ui/queries/queries';
import { QueryKey } from '@ui/queries/queryKey';

import { useCoinMode } from './useCoinMode';

const useUnbondUnlockDate = () => {
  const coinMode = useCoinMode();
  const sdk = useVenoSDK();

  const query = getQuery(QueryKey.UNBOND_UNLOCK_DATE)({ coinMode, sdk });
  const { data, isLoading } = useQuery(query.queryKey, query.queryFn);
  return {
    data,
    isLoading,
  };
};

export default useUnbondUnlockDate;
